import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Drivers from "@/pages/Drivers";
import Vehicles from "@/pages/Vehicles";
import TripsFixas from "@/pages/TripsFixas";
import TripsDiarias from "@/pages/TripsDiarias";
import Reports from "@/pages/Reports";
import RelatorioMensal from "@/pages/RelatorioMensal";
import UsersAdmin from "@/pages/UsersAdmin";
import TripPrint from "@/pages/TripPrint";
import Requests from "@/pages/Requests";
import RequestPrint from "@/pages/RequestPrint";
import Freights from "@/pages/Freights";
import FreightPrint from "@/pages/FreightPrint";
import Inspections from "@/pages/Inspections";
import InspectionPrint from "@/pages/InspectionPrint";
import ServiceOrders from "@/pages/ServiceOrders";
import ServiceOrderPrint from "@/pages/ServiceOrderPrint";
import FuelReceipts from "@/pages/FuelReceipts";
import FuelReceiptPrint from "@/pages/FuelReceiptPrint";

const NITA_EMAILS = ["nyttapatrocinio06@gmail.com"];

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/viagem/:id/imprimir"
                            element={
                                <ProtectedRoute>
                                    <TripPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/solicitacao/:id/imprimir"
                            element={
                                <ProtectedRoute>
                                    <RequestPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/frete/:id/imprimir"
                            element={
                                <ProtectedRoute>
                                    <FreightPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/inspecao/:id/imprimir"
                            element={
                                <ProtectedRoute>
                                    <InspectionPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/os/:id/imprimir"
                            element={
                                <ProtectedRoute allowEmails={NITA_EMAILS}>
                                    <ServiceOrderPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/combustivel/:id/imprimir"
                            element={
                                <ProtectedRoute allowEmails={NITA_EMAILS}>
                                    <FuelReceiptPrint />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="motoristas" element={<Drivers />} />
                            <Route path="veiculos" element={<Vehicles />} />
                            <Route path="viagens-fixas" element={<TripsFixas />} />
                            <Route path="viagens-diarias" element={<TripsDiarias />} />
                            <Route path="solicitacoes" element={<Requests />} />
                            <Route path="fretes" element={<Freights />} />
                            <Route path="inspecoes" element={<Inspections />} />
                            <Route
                                path="ordens-servico"
                                element={
                                    <ProtectedRoute allowEmails={NITA_EMAILS}>
                                        <ServiceOrders />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="combustivel"
                                element={
                                    <ProtectedRoute allowEmails={NITA_EMAILS}>
                                        <FuelReceipts />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="relatorios" element={<Reports />} />
                            <Route path="relatorio-mensal" element={<RelatorioMensal />} />
                            <Route
                                path="usuarios"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <UsersAdmin />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
